import { useUserEventLogger } from '@repo/tracking-service';
import { BottomDrawer } from '@zenterprise-inc/ui';

import { WithdrawalReason } from '@/lib/types/auth';

interface Props {
  list: WithdrawalReason[];
  isVisible: boolean;
  onClose: () => void;
  onClickReason: (reason: WithdrawalReason) => void;
}

export const ReasonDrawer = ({ onClose, isVisible, list, onClickReason }: Props) => {
  const { sendViewEvent } = useUserEventLogger();
  const listData = list?.filter(({ active }) => active).sort((a, b) => a.sequence - b.sequence);

  sendViewEvent('feedback-delete_modal_reason', undefined, { isAllowRetry: true, isUseAirbridge: false });

  return (
    <BottomDrawer.Basic isVisible={isVisible} onCloseDrawer={onClose}>
      <BottomDrawer.Basic.Header isCloseButton onCloseDrawer={onClose}>
        이유를 선택해주세요
      </BottomDrawer.Basic.Header>
      <BottomDrawer.Basic.Contents>
        <ul className={'pb-1 px-6'}>
          {listData?.map((reason) => (
            <li key={reason.id} onClick={() => onClickReason(reason)} className={'py-4 body-16 text-gray-800 cursor-pointer'}>
              {reason.title}
            </li>
          ))}
        </ul>
      </BottomDrawer.Basic.Contents>
    </BottomDrawer.Basic>
  );
};
